import { Button } from '@UILayer/Inputs/Button';
import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// TYPES
import { EButtonEvents } from '@Managers/Events/ButtonEvents';

// MANAGERS & REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { getBetState, getButtonState, getWCAMode } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '../../UILayer.scss';

//IMAGES
import iconMinus from './icon_bet_minus.svg';
import iconPlus from './icon_bet_plus.svg';

import iconMinusWCA from './icon_bet_minus_wca.svg';
import iconPlusWCA from './icon_bet_plus_wca.svg';

import { DOM_ID } from '@UILayer/UILayer.types';

const BetButton: React.FC<{ type: string }> = (data) => {
    const [state, setState] = useReducer((state: { disabled: boolean }, newState: any) => ({ ...state, ...newState }), { disabled: false });

    const gameStoreBetState = useAppSelector(getBetState);
    const gameStoreButtonState = useAppSelector(getButtonState);
    const { t } = useTranslation();
    const wcaMode = useAppSelector(getWCAMode);

    const icons = {
        plus: wcaMode ? iconPlusWCA : iconPlus,
        minus: wcaMode ? iconMinusWCA : iconMinus
    };
    const id = data.type === 'plus' ? DOM_ID.BUTTON_BET_PLUS : DOM_ID.BUTTON_BET_MINUS;

    const btnCN = cn(styles.square_btn, styles.grey_btn, styles.bet_btn, { [styles.disabled]: state.disabled });

    useEffect(() => {
        if (data.type === 'minus') {
            setState({
                disabled: gameStoreBetState.index === 0 || gameStoreButtonState.isBetDecreaseButtonActive === false ? true : false
            });
        }

        if (data.type === 'plus') {
            setState({
                disabled: gameStoreBetState.index === gameStoreBetState.maxIndex || gameStoreButtonState.isBetIncreaseButtonActive === false ? true : false
            });
        }
    }, [gameStoreBetState, gameStoreButtonState]);

    function buttonAction() {
        let betsData = gameStoreBetState;

        if (betsData && !state.disabled)
            switch (data.type) {
                case 'minus':
                    if (betsData.index > 0) EventsCenter.emit(EButtonEvents.BET_DECREASE_BUTTON_PRESSED);
                    break;
                case 'plus':
                    if (betsData.index < betsData.maxIndex) EventsCenter.emit(EButtonEvents.BET_INCREASE_BUTTON_PRESSED);
                    break;
                default:
                    break;
            }
    }

    return (
        <Button id={id} description={t('WCA_TOGGLE_SOUND_BUTTON')} className={btnCN} onChange={buttonAction}>
            <img src={data.type === 'plus' ? icons.plus : icons.minus} alt={data.type === 'plus' ? t('WCA_RISE_BET_BUTTON') : t('WCA_LOWER_BET_BUTTON')} />
        </Button>
    );
};

export default BetButton;
